import { render } from "./pwa-button.vue?vue&type=template&id=9628d39e&scoped=true&ts=true"
import script from "./pwa-button.vue?vue&type=script&lang=ts"
export * from "./pwa-button.vue?vue&type=script&lang=ts"

import "./pwa-button.vue?vue&type=style&index=0&id=9628d39e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9628d39e"]])

export default __exports__